import {
  addDoc, collection, limit, onSnapshot, orderBy, query, serverTimestamp,
  type Timestamp,
} from "firebase/firestore";
import { db } from "./ambiente";
import { perfilQueVale } from "./users";

export interface MessageDoc {
  uid: string;
  name: string;
  photo: string;
  text: string;
  at: Timestamp;
}
export interface Message extends MessageDoc { id: string }

const messagesRef = (cid: string) => collection(db, "challenges", cid, "messages");

/**
 * O bate-papo do desafio.
 *
 * Últimas 300 mensagens, em ordem crescente. O teto existe porque a
 * consulta é ao vivo: sem ele, um grupo ativo por um ano manteria o
 * histórico inteiro em memória e refaria a lista a cada mensagem nova.
 */
export function watchMessages(cid: string, cb: (list: Message[]) => void): () => void {
  const q = query(messagesRef(cid), orderBy("at", "desc"), limit(300));
  return onSnapshot(
    q,
    (snap) => {
      const list = snap.docs.map((d) => ({ id: d.id, ...(d.data() as MessageDoc) }));
      cb(list.reverse());
    },
    () => cb([]),
  );
}

export async function sendMessage(
  cid: string,
  autor: { uid: string; name: string; photo: string },
  text: string,
): Promise<void> {
  /* O `autor` que a tela manda é o do login; o que vale é o de
     `users/{uid}` — senão o recado sai com o nome e a foto do Google
     depois de a pessoa ter trocado os dois em Conta. */
  const quem = await perfilQueVale(autor);
  await addDoc(messagesRef(cid), { ...quem, text, at: serverTimestamp() });
}
